/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Export_No_Event_Group_ErrorInputs */



/**
* | output |
* | --- |
* | "No valid event group found for export" |
*
* @param {Iframe_Remote_Export_No_Event_Group_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_export_no_event_group_error = /** @type {((inputs?: Iframe_Remote_Export_No_Event_Group_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Export_No_Event_Group_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun groupe d'evenements valide trouve pour l'export")
	if (locale === "de") return /** @type {LocalizedString} */ ("Es wurde keine gültige Ereignisgruppe für den Export gefunden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun gruppo di eventi valido trovato per l'esportazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не найдена подходящая группа событий для экспорта.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontró ningún grupo de eventos válido para la exportación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未找到可导出的有效事件组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポートに有効なイベント グループが見つかりません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात के लिए कोई वैध इवेंट समूह नहीं मिला")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum grupo de eventos válido encontrado para exportação.")
	return /** @type {LocalizedString} */ ("No valid event group found for export")
});